import { render, staticRenderFns } from "./card-compare-product.vue?vue&type=template&id=f0442624&scoped=true&"
import script from "./card-compare-product.vue?vue&type=script&lang=js&"
export * from "./card-compare-product.vue?vue&type=script&lang=js&"
import style0 from "./card-compare-product.vue?vue&type=style&index=0&id=f0442624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0442624",
  null
  
)

export default component.exports